// noinspection ES6ModulesDependencies,JSUnresolvedVariable
export const HERE = new H.service.Platform({apikey: HERE_API_KEY})